import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sex.reducer';

export const SexDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sexEntity = useAppSelector(state => state.sex.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sexDetailsHeading">
          <Translate contentKey="apiLocationApp.sex.detail.title">Sex</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{sexEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.sex.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{sexEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.sex.date">Date</Translate>
            </span>
          </dt>
          <dd>{sexEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.sex.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{sexEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.sex.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{sexEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.sex.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{sexEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="male">
              <Translate contentKey="apiLocationApp.sex.male">Male</Translate>
            </span>
          </dt>
          <dd>{sexEntity.male}</dd>
          <dt>
            <span id="female">
              <Translate contentKey="apiLocationApp.sex.female">Female</Translate>
            </span>
          </dt>
          <dd>{sexEntity.female}</dd>
        </dl>
        <Button tag={Link} to="/sex" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sex/${sexEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SexDetail;
